export const urlValidator = (urlString?: string): boolean => {
  if (!urlString || urlString == "undefined") {
    return false;
  }
  const validatorRegex =
    /^https:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
  return validatorRegex.test(urlString);
};
